var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_14339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47134 11.8047C8.73201 12.0653 8.73201 12.4867 8.47134 12.7473L5.60934 15.6093C5.34934 15.8693 5.008 15.9993 4.66667 15.9993C4.32534 15.9993 3.984 15.8693 3.724 15.6093L0.862004 12.7473C0.601337 12.4867 0.601337 12.0653 0.862004 11.8047C1.12267 11.544 1.544 11.544 1.80467 11.8047L4 14V0.666667C4 0.298 4.29867 0 4.66667 0C5.03467 0 5.33334 0.298 5.33334 0.666667V14L7.52867 11.8047C7.78934 11.544 8.21067 11.544 8.47134 11.8047ZM15.138 3.25267L12.276 0.390667C11.7567 -0.128667 10.91 -0.128667 10.3907 0.390667L7.52867 3.25267C7.268 3.51333 7.268 3.93467 7.52867 4.19533C7.78934 4.456 8.21067 4.456 8.47134 4.19533L10.6667 2V15.3333C10.6667 15.702 10.9647 16 11.3333 16C11.702 16 12 15.702 12 15.3333V2L14.1953 4.19533C14.3253 4.32533 14.496 4.39067 14.6667 4.39067C14.8373 4.39067 15.008 4.32533 15.138 4.19533C15.3987 3.93467 15.3987 3.51333 15.138 3.25267Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_14339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.c47eee99cea654396ba3a8cc270dc8af.svg";
export { ForwardRef as ReactComponent };